import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  SimpleShowLayout,
  Show
} from "react-admin";
import { Create, Edit, SimpleForm, TextInput } from "react-admin";





export const TagList = (props) => {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="resource_name" label="Tag Name" />
        <EditButton/>
        <ShowButton/>
      </Datagrid>
    </List>
  );
};

export const TagEdit = (props) => {
  return (
    <Edit title="Edit Tag" {...props}>
      <SimpleForm>
        <TextInput source="resource_name" label="Tag Name" />
      </SimpleForm>
    </Edit>
  );
};


export const TagCreate = (props) => {
  return (
    <Create title="Create Tag" {...props}>
      <SimpleForm>
        <TextInput source="resource_name" label="Tag Name" />
      </SimpleForm>
    </Create>
  );
};



export const TagShow = (props) => {

  return (
    <Show {...props}>
     <SimpleShowLayout>
        <TextField source="resource_name" label="Tag Name" />
      </SimpleShowLayout>
    </Show>
  );
};

